import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';

export const SeparatorStyled = styled.div`
  width: 1px;
  height: 100%;
  background: ${Colors.BrandBlueMiddle};

  &[aria-disabled='true'] {
    background: ${Colors.Grey};
  }
`;
